import React, { useState, useEffect, useContext } from 'react';
import ControlButtonAdd from './ControlButtonAdd';
import ControlButtonDelete from './ControlButtonDelete';
import ControlButtonUpdate from './ControlButtonUpdate';
import ControlButtonShow from './ControlButtonShow';
import ControlButtonVisibility from './ControlButtonVisibility';
import ControlItem from './ControlItem';
import Pager from './Pager';
import Loading from './Loading';
import SuccessAlert from './SuccessAlert';

import MyNewsContext from '../context/NewsContext';

import ModalNews from './ModalNews';
import ModalItemsDelete from './ModalItemsDelete';
import ModalNewsAdd from './ModalNewsAdd';
import ModalNewsUpdate from './ModalNewsUpdate';

const ControlNews = () => {
    const {getNewsAdmin, news, files, maxPage, setPageAdmin, pageAdmin, error, changeNewVisibility, loading, setNewN, setImage, setError, deleteNew} = useContext(MyNewsContext);

    const[isModalNewsOpen, setIsModalNewsOpen] = useState(false);
    const[isModalItemsDeleteOpen, setIsModalItemsDeleteOpen] = useState(false);
    const[isModalNewsAddOpen, setIsModalNewsAddOpen] = useState(false);
    const[isModalNewsUpdateOpen, setIsModalNewsUpdateOpen] = useState(false);

    const[itemId, setItemId] = useState(null);
    const[successAlert, setSuccessAlert] = useState(null);

    const handleChangeNewVisibility = async (newId) => {
        const res = await changeNewVisibility(newId);
        if(res.error){
            setError({"error": true, "message": res.response})
            setTimeout(() => {
                setError({"error": false, "message": ""});
            }, 3000);
        }else{
            setError({"error": false, "message": ""})
            setSuccessAlert("Visibilidad cambiada correctamente")
            setTimeout(() => {
                setSuccessAlert(null)
            }, 2000);
        }
    }

    useEffect(() =>  {
        getNewsAdmin();
    }, [pageAdmin]);

    useEffect(() => {
        setPageAdmin(0);
    }, []);

    return (
        <div className='animation-appear-top-center'>
            <ModalNews isModalNewsOpen={isModalNewsOpen} setIsModalNewsOpen={setIsModalNewsOpen} />
            <ModalItemsDelete isModalItemsDeleteOpen={isModalItemsDeleteOpen} setIsModalItemsDeleteOpen={setIsModalItemsDeleteOpen} setSuccessAlert={setSuccessAlert} loading={loading} deleteFunction={deleteNew} itemId={itemId} />
            <ModalNewsAdd isModalNewsAddOpen={isModalNewsAddOpen} setIsModalNewsAddOpen={setIsModalNewsAddOpen} setSuccessAlert={setSuccessAlert} />
            <ModalNewsUpdate isModalNewsUpdateOpen={isModalNewsUpdateOpen} setIsModalNewsUpdateOpen={setIsModalNewsUpdateOpen} setSuccessAlert={setSuccessAlert} />
            <SuccessAlert isVisible={successAlert} />
            <div className='flex flex-col'>
                <ControlButtonAdd onClick={()=>setIsModalNewsAddOpen(true)} />
                {error.error ? <h1 className='text-center text-red-500 w-full my-4'>{error.message}</h1> : null}
                {news && news.length > 0 && news.map((newN, index) => (
                        <ControlItem key={index} title={newN.newTitle} text={newN.newDescription}>
                            <ControlButtonShow onClick={()=>{setNewN(newN); setImage(`data:image/png;base64,${files[index]}`); setIsModalNewsOpen(true)}} />
                            <ControlButtonUpdate onClick={()=>{setNewN(newN); setIsModalNewsUpdateOpen(true)}} />
                            <ControlButtonVisibility visible={newN.visible} onClick={()=>handleChangeNewVisibility(newN.newId)} />
                            <ControlButtonDelete onClick={()=>{setItemId(newN.newId); setIsModalItemsDeleteOpen(true)}} />
                        </ControlItem>
                    ))
                }
                <div>
                    <Loading isLoading={loading} />
                    {news && news.length < 1 && <h1 className='text-center w-full font-light my-4'>No hay registros para mostrar</h1>}
                    <div className='flex justify-center mb-4'>
                        <Pager maxPage={maxPage} setPage={setPageAdmin} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ControlNews;